import { sanitizeSegment } from "../../storage/fsa.ts";
import { shortHash } from "../../storage/hash.ts";
import type { TodoTaskList } from "./types.ts";

/**
 * Output tree for Tasks (ARCHITECTURE.md §7): `tasks/<list>.json`.
 *
 * A hash suffix is appended the same way Teams' chatKey() does — Graph does
 * not enforce unique list names the way it does for sibling mail folders, so
 * two lists named "Personal" would otherwise collide onto the same file.
 */

const MAX_NAME_LENGTH = 60;

export async function listKey(list: TodoTaskList): Promise<string> {
    const label = sanitizeSegment(list.displayName || "list", MAX_NAME_LENGTH);
    const suffix = await shortHash(list.id, 8);
    return `${label || "list"}_${suffix}`;
}

export function listPath(key: string): string {
    return `tasks/${key}.json`;
}
